import logo from "../../../media/logo.svg";
import instagram from "../../../media/instagram.svg";
import facebook from "../../../media/facebook.svg";
import "./footer.scss";

const Footer = () => {
  return (
    <footer>
      <div className="flex flex-col mx-8">
        <div className="flex items-center justify-between md:justify-start py-8">
          <img className="w-[195px] h-[45px]" src={logo} alt="Club La Voz" />
          <div className="flex md:pl-8 pb-1">
            <a
              href="https://www.facebook.com/ClubLaVoz"
              target="_blank"
              rel="noreferrer"
            >
              <img className=" w-auto h-5 pr-4" src={facebook} alt="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/clublavoz"
              target="_blank"
              rel="noreferrer"
            >
              <img className="w-auto h-5" src={instagram} alt="Instagram" />
            </a>
          </div>
        </div>
        <div className="hidden grid-cols-1 md:grid-cols-3 font-body text-base text-gray-900">
          <ul className="py-4 pr-8">
            <li className="font-bold">Club La Voz</li>
            <li>Inicio</li>
            <li>Club La Voz</li>
            <li>Beneficios</li>
            <li>Pedí tu tarjeta</li>
            <li>Contacto</li>
          </ul>
          <ul className="py-4 pr-8">
            <li className="font-bold">Info relacionada</li>
            <li>Reglamento</li>
            <li>Adherí tu comercio</li>
            <li>Preguntas frecuentes</li>
            <li>Facturación electrónica</li>
            <li>Instructivo Facturación</li>
          </ul>
          <ul className="py-4">
            <li className="font-bold">Red de sitios</li>
            <li>
              <a href="https://www.lavoz.com.ar/" className="text-gray-700">
                La Voz
              </a>
            </li>
            <li>
              <a href="https://www.lavoz.com.ar/deportes/" target="blank">
                Mundo D
              </a>
            </li>
            <li>
              <a href="https://www.lavoz.com.ar/vos/" target="blank">
                VOS
              </a>
            </li>
            <li>
              <a href="https://clasificados.lavoz.com.ar/" target="blank">
                Clasificados
              </a>
            </li>
            <li>
              <a href="https://www.lavoz.com.ar/agro/" target="blank">
                Agrovoz
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
